const downloadFile = (url:string,name:string) => {
    const a = document.createElement('a');
    a.href = url;
    a.target = '_blank'; // Open in new tab
    a.rel = 'noopener noreferrer'; // Security measure
    a.download =name; // Optional: set custom file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
export default downloadFile;